<template v-if="caseList && caseList.length">
  <div
    v-if="data.type.key === 'horizon'"
    class="widget-case-list-wrapper horizontal"
  >
    <swiper :options="swiperOptions">
      <swiper-slide v-for="item in caseList" :key="item.id">
        <senior-case-item :item="item"></senior-case-item>
      </swiper-slide>
      <div slot="button-prev" class="swiper-button-prev">
        <i class="iconfont icon-zuocefanhuijiantou"></i>
      </div>
      <div slot="button-next" class="swiper-button-next">
        <i class="iconfont icon-youcefanhuijiantou"></i>
      </div>
    </swiper>
  </div>
  <div
    v-else-if="['verticle', 'title'].indexOf(data.type.key) > -1"
    class="widget-case-list-wrapper vertical"
  >
    <senior-case-item
      v-for="item in caseList"
      :key="item.id"
      :item="item"
      type="list"
    ></senior-case-item>
  </div>
</template>

<script>
import SeniorCaseItem from '@/components/senior/SeniorCaseItem'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { THIRD_API } from '@/global/config'

export default {
  components: {
    swiper,
    swiperSlide,
    SeniorCaseItem
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      caseList: [],
      itemMap: {},
      swiperOptions: {
        freeMode: true,
        spaceBetween: 26,
        slidesPerView: 'auto',
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          init() {
            this.setTranslate(24)
          }
        }
      }
    }
  },
  created() {
    this.getCaseList()
  },
  methods: {
    async getCaseList() {
      this.data.source.forEach(item => {
        this.itemMap[item.id] = item
      })
      const res = await this.$http.get(THIRD_API.alkSeniorCollect.link, {
        params: {
          ids: Object.keys(this.itemMap).join(',')
        }
      })
      this.caseList = res.data.map(item => {
        const { alias } = this.itemMap[item.id]
        item.activity_name = alias || item.activity_name
        return item
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-case-list-wrapper {
  border-radius: 3px;
  margin: 16px auto;
  &.horizontal {
    background-color: #fafafb;
    padding: 24px 0;
  }
  &.vertical {
    width: 688px;
  }
}
.senior-case-item-wrapper {
  background-color: #ffffff;
  &.card-type {
    width: 320px;
  }
}
.swiper-container {
  position: relative;
}
.swiper-slide {
  width: auto;
  height: auto;
}
.swiper-button-next,
.swiper-button-prev {
  background-color: #ffffff;
  width: 32px;
  height: 58px;
  line-height: 58px;
  margin-top: -29px;
  background-image: none;
  i {
    font-size: 20px;
    color: #363636;
    font-weight: bold;
    position: absolute;
  }
  &.swiper-button-disabled {
    display: none;
  }
}
.swiper-button-next {
  right: 0;
  border-radius: 100px 0 0 100px;
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.15);
  i {
    left: 10px;
  }
}
.swiper-button-prev {
  left: 0;
  border-radius: 0 100px 100px 0;
  box-shadow: 4px 0 8px rgba(0, 0, 0, 0.15);
  i {
    left: 5px;
  }
}
</style>
